import { useEffect } from 'react';

/**
 * 🛡️ Ultimate Anti-Developer Tools Hook
 * Includes:
 * - Developer Tools Detection with Redirect
 * - Disable Right-Click and Shortcuts
 * - Scroll State Detection
 */
function useAntiDevTools() {
  /**
   * 🛡️ 1. Developer Tools Detection and Redirect
   */
  useEffect(() => {
    let devToolsOpened = false;

    // Console Trick
    const detectConsoleTrick = () => {
      const element = new Image();
      Object.defineProperty(element, 'id', {
        get: () => {
          devToolsOpened = true;
          return 'Developer Tools Detected';
        },
      });

      try {
        console.log(element);
      } catch (e) {
        devToolsOpened = true;
      }
    };

    // Window Size Anomaly
    const detectWindowSize = () => {
      const threshold = 160;
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        devToolsOpened = true;
      }
    };

    // Debugger Detection
    const detectDebugger = () => {
      const start = performance.now();
      (() => {})();
      const end = performance.now();
      if (end - start > 100) {
        devToolsOpened = true;
      }
    };

    // Combined Detection Logic
    const detectDevTools = () => {
      detectConsoleTrick();
      detectWindowSize();
      detectDebugger();

      if (devToolsOpened) {
        document.body.innerHTML = '';
        document.body.style.display = 'none';
        window.location.href = 'about:blank';
      }
    };

    const interval = setInterval(detectDevTools, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  /**
   * 🖱️ 2. Disable Right-Click and Key Combinations
   */
  useEffect(() => {
    // Disable Right-Click
    document.oncontextmenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable Common Developer Shortcuts
    const disableShortcuts = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && e.key === 'I') ||
        (e.ctrlKey && e.shiftKey && e.key === 'J') ||
        (e.ctrlKey && e.key === 'u') ||
        (e.ctrlKey && e.key === 's') ||
        (e.ctrlKey && e.key === 'c') ||
        (e.ctrlKey && e.key === 'v')
      ) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('keydown', disableShortcuts);

    return () => {
      document.oncontextmenu = null;
      document.removeEventListener('keydown', disableShortcuts);
    };
  }, []);

  /**
   * 🖱️ 3. Scroll State Detection
   */
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
}

export default useAntiDevTools;
